import * as React from "react";

import ThemeLiquidFilePng from "./ThemeLiquidFile.png";

export const ThemeLiquidFile = () => {
  return (
    <img
      id="theme-liquid-file"
      src={ThemeLiquidFilePng}
      alt="Theme Liquid File"
      draggable="false"
      style={{ height: "100%", width: "auto", objectFit: "contain" }}
    />
  );
};
